<template>
  <div class="orderBody">
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
      :style="pullStyle"
      v-if="list.length != 0"
    >
      <div class="allOrder">
        <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="list.length != 0">" -->

        <div class="vant-list-div">
          <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="this.list.length === 0 ? '' : '没有更多了'"
            @load="onLoad"
          >
            <van-cell class="lists" v-for="(item, index) in list" :key="index">
              <div class="oder-item">
                <van-row class="order_content" @click="handleDetail(item)">
                  <van-col span="19">
                    <p class="order_name">
                      {{ item.info && item.info.hotel_name }}
                    </p>

                    <van-row class="content_left">
                      <van-col span="7">
                        <img
                          class="order_img"
                          :src="item.info && item.info.picture"
                        />
                      </van-col>
                      <van-col span="1"></van-col>
                      <van-col span="16">
                        <p class="order_room">
                          <span>{{ item.room_number }}间,</span>
                          <span>{{ item.info && item.info.room_name }}</span>
                        </p>
                        <p class="order_time">
                          <span
                            >{{ item.arrival_date
                            }}<span class="time_gap">-</span
                            >{{ item.departure_date }}</span
                          >
                        </p>
                        <p class="order_price">
                          红包抵扣：{{
                            item && item.deduct_coin
                              ? item &&
                                item.deduct_coin &&
                                item.deduct_coin.toFixed(2)
                              : 0 + ".00"
                          }}
                        </p>
                      </van-col>
                    </van-row>
                  </van-col>
                  <van-col span="5" class="content_right">
                    <p class="content_status">{{ item.status_text }}</p>
                    <span
                      v-if="item.is_after_sales === 40"
                      class="content_unsubscribe"
                      >退款失败</span
                    >
                    <p
                      :class="
                        item.is_after_sales === 40
                          ? 'content_price mar_un8'
                          : 'content_price'
                      "
                    >
                      ¥{{ item.pay_money }}
                    </p>
                  </van-col>
                </van-row>
                <div class="oder-button">
                  <van-row
                    v-if="
                      item.is_after_sales === 10 || item.is_after_sales === 20
                    "
                  >
                    <van-col span="24" class="content_edit_body">
                      <van-button
                        type="default"
                        @click="handleReserve(item)"
                        class="cancel_order content_btn pay_order  mar_le"
                        >再次预订</van-button
                      >
                    </van-col>
                  </van-row>
                  <van-row v-else-if="item.is_after_sales === 30">
                    <van-col span="24" class="content_edit_body">
                      <van-button
                        type="default"
                        class="cancel_order content_btn btn_bor"
                        @click="handleDel(item)"
                        >删除订单</van-button
                      >
                      <van-button
                        type="default"
                        @click="handleReserve(item)"
                        class="cancel_order content_btn pay_order mar_le"
                        >再次预订</van-button
                      >
                    </van-col>
                  </van-row>
                  <van-row v-else-if="item.is_after_sales === 40">
                    <van-col span="24" class="content_edit_body">
                      <van-button
                        type="default"
                        @click="handleReserve(item)"
                        class="cancel_order content_btn btn_bor  mar_le"
                        >再次预订</van-button
                      >
                      <a href="tel:4000571671" @click="iOStel('4000571671')"
                        ><van-button
                          type="default"
                          class="pay_order content_btn mar_le"
                        >
                          联系客服
                        </van-button></a
                      >
                    </van-col>
                  </van-row>
                  <van-row v-else-if="item.status === 10">
                    <van-col span="24" class="content_edit_body">
                      <van-button
                        type="default"
                        class="cancel_order btn_bor content_btn"
                        @click="handleCancel(item)"
                        >取消订单</van-button
                      >
                      <van-button
                        type="default"
                        @click="handleToPay(item)"
                        class="pay_order content_btn mar_le"
                        >去支付</van-button
                      >
                    </van-col>
                  </van-row>
                  <van-row
                    v-else-if="
                      item.status === -10 ||
                        item.status === -20 ||
                        item.status === 50
                    "
                  >
                    <van-col span="24" class="content_edit_body">
                      <van-button
                        type="default"
                        class="cancel_order btn_bor content_btn"
                        @click="handleDel(item)"
                        >删除订单</van-button
                      >
                      <van-button
                        type="default"
                        @click="handleReserve(item)"
                        class="cancel_order content_btn pay_order  mar_le"
                        >再次预订</van-button
                      >
                    </van-col>
                  </van-row>
                  <van-row v-else-if="item.status === 20 || item.status === 25">
                    <van-col span="24" class="content_edit_body">
                      <van-button
                        type="default"
                        @click="handleReserve(item)"
                        class="cancel_order content_btn pay_order  mar_le"
                        >再次预订</van-button
                      >
                    </van-col>
                  </van-row>
                  <van-row v-else-if="item.status === 30">
                    <van-col span="24" class="content_edit_body">
                      <van-button
                        type="default"
                        class="cancel_order btn_bor content_btn"
                        @click="handleCancel(item)"
                        >取消订单</van-button
                      >
                      <van-button
                        type="default"
                        :disabled="item.push_msg_log"
                        class="cancel_order btn_bor content_btn  mar_le"
                        @click="handlelSendLetter(item)"
                        >{{
                          item.push_msg_log ? "已发确认函" : "重发确认函"
                        }}</van-button
                      >
                      <van-button
                        type="default"
                        @click="handleReserve(item)"
                        class="cancel_order content_btn pay_order  mar_le"
                        >再次预订</van-button
                      >
                    </van-col>
                  </van-row>
                  <van-row v-else-if="item.status === 40">
                    <van-col
                      span="24"
                      class="content_edit_body"
                      v-if="item.return_credits_status == 1"
                    >
                      <van-button
                        type="default"
                        @click="handleReserve(item)"
                        class="cancel_order btn_bor content_btn  mar_le"
                        >再次预订</van-button
                      >
                      <van-button
                        type="default"
                        @click="handleGetCredits(item)"
                        class="order_integral content_btn mar_le"
                        >领取积分</van-button
                      >
                    </van-col>
                    <van-col
                      span="24"
                      class="content_edit_body"
                      v-if="item.return_credits_status == 2"
                    >
                      <van-button
                        type="default"
                        class="cancel_order btn_bor content_btn"
                        @click="handleDel(item)"
                        >删除订单</van-button
                      >
                      <van-button
                        type="default"
                        @click="handleReserve(item)"
                        class="cancel_order content_btn pay_order  mar_le"
                        >再次预订</van-button
                      >
                    </van-col>
                  </van-row>
                </div>
              </div>
            </van-cell>
          </van-list>
        </div>
      </div>
    </van-pull-refresh>
    <van-row class="empty" v-if="list.length == 0">
      <van-col class="emptyMsg" span="24">
        <img src="../../../assets/hotel/img/order/no-order.png" />
        <p class="tip">您还没有相关订单</p>
        <p class="tip tip1">快去看看有没有合适的酒店～</p>
      </van-col>
    </van-row>
    <div class="mar_to_20" v-if="list.length == 0">
      <guessOrder />
    </div>
    <van-popup v-model="show" class="tipMSG">
      <div class="box">
        <img src="../../../assets/common/BG@2x.png" alt="" />
        <p class="title">温馨提示</p>
        <p class="tips">亲，您真的要删除该订单吗？</p>
        <div style="display:flex">
          <span class="left" @click="cancle()">取消</span>
          <span class="right" @click="confirm()">确认</span>
        </div>
      </div>
    </van-popup>
    <div class="order-list-loading" v-if="loading1">
      <img src="../../../assets/common/loading.gif" />
    </div>
  </div>
</template>
<script>
import defaultImg from "@/assets/common/compare.png";
import guessOrder from "./guessOrder.vue";
import dsbridge from "dsbridge";
import {
  getCredits,
  sendLetter,
  delOrder,
  getOrderDetail,
  getCityCode,
  getOrderList,
  getPayment,
} from "@/pages/hotel/api";
import { mapMutations, mapState } from "vuex";
export default {
  components: {
    guessOrder,
  },
  props: {
    orderStyle: {
      type: Number,
      detault: 0,
    },
    active: {
      type: Number,
      default: 0,
    },
  },
  name: "orderList",
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      page: 0,
      status: 0,
      list: [],
      show: false,
      order_sn: "",
      pullStyle: {},
      facility: "",
      loading1: false,
    };
  },
  // filters: {
  //   dateFormat(date) {
  //     return date.replace(/-/g, ".");
  //   },
  // },
  created() {
    this.onLoad();
    // this.pullStyle.height = document.body.clientHeight - (88 + 96) + "px";
  },
  mounted() {
    window.setPay = this.setPay;
    this.deductionUA();
    if (!sessionStorage.getItem("coordinate")) {
      sessionStorage.setItem(
        "coordinate",
        JSON.stringify({
          longitude: 116.397072,
          latitude: 39.909593,
        })
      );
      let u = navigator.userAgent,
        app = navigator.appVersion;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        window.setLocation = this.setLocation;
        this.params("", "", "getLocation");
      }
      if (isiOS) {
        dsBridge.call("getLocation", (positionObj) => {
          this.setLocation(positionObj);
        });
      }
    }
    // else{
    //     this.coordinate = JSON.parse(sessionStorage.coordinate);
    // }
  },
  computed: {
    finishedText() {
      if (this.list.length && !this.loading && !this.refreshing) {
        return "- 没有更多了 -";
      }
      return "";
    },
    ...mapState({
      hoteldetail: (state) => state.hotel.hoteldetail,
    }),
  },
  methods: {
    ...mapMutations(["setState"]),
    setPay(v) {
      let data = JSON.parse(v);
      if (data.code == 0) {
        this.loading1 = true;
        this.$toast("支付成功");
        let countLimit1 = 0;
        const intervalId1 = setInterval(() => {
          countLimit1++;
          //状态为待支付
          if (
            this.orderStyle === 10 &&
            !~this.list.indexOf((_) => _.order_sn === this.order_sn)
          ) {
            clearInterval(intervalId1);
            this.loading1 = false;
            return;
          }

          for (let i = 0; i < this.list.length; i++) {
            if (
              this.order_sn === this.list[i].order_sn &&
              this.list[i].status === 20
            ) {
              clearInterval(intervalId1);
              this.loading1 = false;
              return;
            }
          }
          // this.page = 0;
          // this.list = [];
          // this.onLoad();
          this.onRefresh();
          if (countLimit1 >= 3) {
            clearInterval(intervalId1);
            this.loading1 = false;
          }
        }, 1000);
      } else {
        this.$toast("支付失败");
      }
    },
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        this.facility = "ios";
      } else if (/android/.test(ua)) {
        this.facility = "android";
      }
    },
    onLoad() {
      this.page++;
      this.getInfo();
    },
    onRefresh() {
      this.finished = false;
      this.page = 0;
      this.list = [];
      // this.getInfo();
      this.onLoad();
    },
    getInfo() {
      let params = {};
      switch (this.orderStyle) {
        case 0:
          params = {};
          break;
        case 10:
          params = { status: 10, is_after_sales_status: 0 };
          break;
        case 25:
          params = {
            status: 25,
            is_after_sales_status: 0,
          };
          break;
        case 40:
          params = {
            status: 40,
            is_after_sales_status: 0,
          };
          break;
        case 20:
          params = {
            status: 0,
            is_after_sales_status: 20,
          };
          break;
        case 30:
          params = {
            status: 0,
            is_after_sales_status: 30,
          };
          break;
        case -10:
          params = {
            status: -10,
            is_after_sales_status: 0,
          };
          break;
      }
      getOrderList({ page: this.page, ...params })
        .then((res) => {
          if (res.total === 0 || res.list.length === 0) {
            this.finished = true;
            this.loading = false;
            this.refreshing = false; // 解决空列表下拉一直加载中问题
            return;
          }
          for (let i in res.list) {
            switch (res.list[i].status) {
              case 10:
                res.list[i].status_text = "待支付";
                break;
              case 20:
                res.list[i].status_text = "预订待处理";
                break;
              case 25:
                res.list[i].status_text = "预订待处理";
                break;
              case 30:
                res.list[i].status_text = "预订成功";
                break;
              case 40:
                res.list[i].status_text = "已完成";
                break;
              case 50:
                res.list[i].status_text = "已完成";
                break;
              case -10:
                res.list[i].status_text = "已关闭";
                break;
              case -20:
                res.list[i].status_text = "已关闭";
                break;
            }
            switch (res.list[i].is_after_sales) {
              case 10:
                res.list[i].status_text = "退订中";
                break;
              case 20:
                res.list[i].status_text = "退订中";
                break;
              case 30:
                res.list[i].status_text = "已退订";
                break;
              case 40:
                res.list[i].status_text = "退订中";
                break;
            }
            this.list.push(res.list[i]);
          }
          this.loading = false;
          if (res.current_page === res.last_page) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.refreshing) {
            this.$toast("刷新成功");
            this.refreshing = false;
          }
          if (!this.finished && !this.loading && this.list.length <= 5) {
            this.onLoad();
          }
          // this.prize_image = _list.forEach(item => prize_picture)
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
          // this.error = true
          // this.refreshing = false
        });
    },
    //取消订单
    handleCancel(val) {
      this.$router.push({
        path: "/hotel/cancelOrder",
        query: {
          order_sn: val.order_sn,
          routing: "list",
          active: this.active,
        },
      });
    },
    //重发确认函
    handlelSendLetter(val) {
      sendLetter({
        order_sn: val.order_sn,
      })
        .then((res) => {
          this.page = 0;
          this.list = [];
          this.onLoad();
          this.$toast("操作成功~");
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    //删除订单
    handleDel(val) {
      this.show = true;
      this.order_sn = val.order_sn;
    },

    confirm() {
      delOrder({
        order_sn: this.order_sn,
      })
        .then((res) => {
          this.page = 0;
          this.list = [];
          this.onLoad();
          this.$toast("删除成功");
          this.show = false;
          // this.$router.push({
          //   path: "/hotel/myOrder",
          // });
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    cancle() {
      this.show = false;
    },
    //再次预定
    handleReserve(val) {
      this.$router.push({
        path: "/hotel/detail",
        query: {
          hotel_id: val.info && val.info.hotel_id,
          active: this.active,
          back: "order",
        },
      });
    },
    //联系客服
    iOStel(phoneString) {
      let ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua) && !this.$route.query.from) {
        this.phone(phoneString);
      }
    },
    phone(phoneString) {
      this.tel = phoneString;
      this.params(this.tel, this.tel, "phone");
    },
    //去支付
    handleToPay(item) {
      getPayment({ order_sn: item.order_sn })
        .then((res) => {
          //支付金额订单红包折扣订单编号订单类型
          const param = {
            actual_amount: item.pay_money,
            order_amount: item.order_money,
            ordersn: item.order_sn,
            order_type: "hotelv2",
            // url:'/hotel/myOrder?active='+this.active
          };
          this.order_sn = item.order_sn;
          if (this.facility == "ios") {
            let that = this;
            dsbridge.call("goPay", JSON.stringify(param), function(v) {
              that.setPay(v);
            });
          } else if (this.facility == "android") {
            this.params(JSON.stringify(param), JSON.stringify(param), "goPay");
          }
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    //领取积分
    handleGetCredits(val) {
      getCredits({
        order_sn: val.order_sn,
      })
        .then((res) => {
          this.page = 0;
          this.list = [];
          this.$toast("您已成功领取积分");
          this.onLoad();
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    handleDetail(val) {
      if(val.platform_id===0){
        return this.$toast("迁移订单无法查看详情");
      }
      this.$router.push({
        path: "/hotel/statusDetail",
        query: {
          order_sn: val.order_sn,
          // after_status:this.after_status,
          // status:this,status
        },
      });
    },
    setLocation(positionObj) {
      let obj = JSON.parse(positionObj);
      if (obj.longitude != "0") {
        //设置app传来的经纬度
        this.longitude = obj.longitude; //经度
        this.latitude = obj.latitude; //纬度
        sessionStorage.setItem(
          "coordinate",
          JSON.stringify({
            longitude: this.longitude,
            latitude: this.latitude,
          })
        );
        //逆向编码-经纬度转城市code
        // window.onload=()=>{
        this.position();
        // }
      } else {
        this.setState([
          {
            name: "searchCity",
            value: {
              name: "定位失败",
              value: {},
              bool: false,
            },
          },
        ]);
        this.hoteldetail.canTakeTaxi = false;
        this.setState([
          {
            name: "hoteldetail",
            value: this.hoteldetail,
          },
        ]);
      }
    },
    position() {
      restapiLongitudeLatitude({
        longitude: this.longitude,
        latitude: this.latitude,
      }).then((res) => {
        if (res.status === "1") {
          let address = res.regeocode.addressComponent;
          let obj = {};
          let pname = address.adcode.slice(0, 2);
          let codeParams = {};
          switch (pname) {
            case "50": //重庆
            case "31": //上海
            case "11": //北京
            case "12":
              codeParams = {
                province: address.province.split("市")[0],
                city: address.province.split("市")[0],
                county: address.district.split("区")[0],
              };
              break; //天津
            case "82": //澳门
            case "81": //香港
              codeParams = {
                province: address.province.split("特别行政区")[0],
                city: address.province.split("特别行政区")[0],
                county: address.district.split("区")[0],
              };
              break;
            case "71": //台湾
              codeParams = {
                province: address.province.split("省")[0],
                city: address.province.split("省")[0],
                county: address.province.split("省")[0],
              };
              break;
            default:
              codeParams = {
                province: address.province.split("省")[0],
                city: address.city.split("市")[0],
                county: address.district.split("区")[0],
              };
          }
          getCityCode(codeParams).then((res) => {
            let name = `${codeParams.city}`;
            this.setState([
              {
                name: "searchCity",
                value: {
                  name: name,
                  value: {
                    ...codeParams,
                    name: name,
                    code: res.code,
                  },
                  bool: true,
                },
              },
            ]);
          });
          sessionStorage.position = JSON.stringify(obj);
        } else {
          this.setState([
            {
              name: "searchCity",
              value: {
                name: "定位失败",
                value: {},
                bool: false,
              },
            },
          ]);
          this.hoteldetail.canTakeTaxi = false;
          this.setState([
            {
              name: "hoteldetail",
              value: this.hoteldetail,
            },
          ]);
        }
      });
    },
  },
};
</script>
<style lang="less">
.vant-list-div {
  margin-top: 1rem;
  padding-bottom: 1.5rem;
}
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
.orderBody {
  overflow-y: auto;
  height: 100%;
  box-sizing: border-box;
  padding-bottom: 5.2rem;
  .empty {
    padding-top: 1rem;
    .emptyMsg {
      text-align: center;
      img {
        width: 20rem;
        height: 20rem;
        display: inline-block;
        margin-top: 3.5rem;
        display: inline-block;
      }
      .tip {
        color: #181818;
        font-size: 1.7rem;
        margin-top: 1.7rem;
        height: 2rem;
        line-height: 2rem;
      }
      .tip1 {
        color: #999999;
        font-size: 1.5rem;
        margin-top: 0.5rem;
      }
    }
  }
  .mar_to_20 {
    margin-top: 2rem;
  }
  .tipMSG {
    width: 70%;
    border-radius: 1rem;
    .box {
      img {
        display: block;
        width: 100%;
      }
      .title {
        color: #333;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 4.7rem;
        margin-top: 0.8rem;
        text-align: center;
      }
      .tips {
        color: #333;
        font-size: 1.3rem;
        line-height: 1.8rem;
        text-align: center;
        margin-bottom: 3rem;
        padding: 0 1rem;
      }
      span {
        width: 50%;
        border-top: solid 1px #f2f2f2;
        line-height: 4.3rem;
        color: #999;
        font-size: 1.4rem;
        text-align: center;
        display: inline-block;
      }
      .right {
        color: #e6212f;
        width: calc(50% - 0.1rem);
        border-left: solid 1px #f2f2f2;
      }
      .right_big {
        width: 100%;
        border-left: none;
      }
    }
  }
}
.order_content {
  // font-weight: 600;
  .order_name {
    font-size: 1.6rem;
    color: #333;
    font-weight: 600;
  }
  .order_img {
    width: 8rem;
    height: 8rem;
    border-radius: 0.8rem;
    object-fit: cover;
  }
  .order_room {
    color: #333;
    font-size: 1.4rem;
    span:nth-child(2) {
      margin-left: 0.6rem;
    }
  }
  .time_gap {
    margin: 0 0.2rem;
  }
  .order_price {
    color: #f9591b;
    font-size: 1.4rem;
  }
  .order_time {
    font-size: 1.4rem;
    color: #999;
  }
  .content_left {
    margin-top: 1rem;
  }
  .content_right {
    text-align: right;
  }
  .content_status {
    color: #108b30;
    font-size: 1.4rem;
  }
  .content_price {
    font-size: 1.4rem;
    margin-top: 1rem;
    color: #333;
  }
  .mar_un8 {
    margin-top: -0.8rem;
  }
  .content_unsubscribe {
    color: #f84737;
    transform: scale(0.9);
    font-size: 1.1rem;
    margin-top: -0.8rem;
    margin-right: -0.3rem;
    display: block;
  }
}
.content_edit_body {
  text-align: right;
}

.content_btn {
  height: 3.2rem;
  width: 8rem;
  line-height: 3.2rem;
  border-radius: 1.5rem;
  font-size: 1.4rem;
  padding: 0;
  border: none;
  font-weight: 600;
}
.cancel_order {
  color: #666666;
  // border: 1px solid #666666;
}
.btn_bor {
  border: 1px solid #333;
  font-weight: normal;
}
.pay_order {
  background: #108b30;
  color: #ffffff;
}
.order_integral {
  background-image: linear-gradient(to right, #ff7742, #ff5a4b);
  color: #fff;
}
.mar_le {
  margin-left: 1.5rem;
}
.van-pull-refresh {
  overflow-y: scroll;
  height: 100%;
}
.allOrder {
  // font-weight:600;
  background-color: #ffffff;
  height: 100%;
  margin-top: 1rem;
  .guessYouLikeBody {
    width: calc(100% - 2rem);
    margin: 0 auto;
    .guessYouLike {
      color: #333333;
      font-size: 1.8rem;
      font-weight: 600;
      margin: 5rem 0 2rem;
    }
  }
  .van-pull-refresh {
    padding: 0 1.6rem;
    // height: 591rem; //解决无限滚动问题,及列表最后一个显示不全问题。
    // padding: 0 16px 400px 16rem;
    // overflow-y: scroll;
    height: 100%;
    -webkit-overflow-scrolling: touch;
    .lists {
      border-radius: 0.5rem;
      background: #fff;
      padding: 1.6rem 0;
      border-bottom: 0.1rem solid #eee;
    }
    .lists:nth-of-type(1) {
      margin-top: 0rem !important;
      padding-top: 0;
    }
  }
  .lists:nth-last-of-type(3) {
    border-bottom: none !important;
  }
  .van-pull-refresh > .van-list__finished-text {
    padding-bottom: 6rem !important;
  }
  .van-list__finished-text {
    color: #999999;
    font-size: 1.5rem;
    line-height: 2.1rem;
    text-align: center;
    margin-top: 1.5rem;
    margin-bottom: 5.3rem;
  }
  .van-cell:not(:last-child)::after {
    border: none !important;
  }
}

.isiOSX {
  padding-top: 44px;
}
.order-list-loading {
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  img {
    width: 35%;
    margin-top: 65%;
  }
}
.allOrder .lists:nth-last-of-type(3) {
  border-bottom: none !important;
  .oder-item {
    padding-bottom: 0.1rem;
    &::before {
      height: 0;
    }
  }
}
</style>
<style scoped lang="less">
.van-cell:not(:last-child):after {
  left: 0;
}
.oder-item {
  position: relative;
  padding-bottom: 20px;
  &::before {
    content: "";
    height: 0.1rem;
    background: #eeeeee;
    width: 100%;
    position: absolute;
    bottom: -0;
  }
}
</style>
